var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nc-container',{attrs:{"id":"footer"}},[_c('nc-row',[_c('nc-column',[_vm._v(" Data from "),_c('a',{attrs:{"href":"https://github.com/alexislours/ACNHAPI","target":"_blank"}},[_vm._v("ACNH API")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }